<template>
  <el-table
    ref="table"
    :data="list"
    border
    :max-height="height"
    style="width: 100%"
    tooltip-effect="dark"
    :stripe="false"
    @selection-change="handleSelectionChange"
    :class="[`row-cell-height${rowHeight}`]"
    :row-key="
      rowKey
        ? (row) => {
            return row[rowKey];
          }
        : null
    "
    v-on="$listeners"
    v-bind="attrs"
  >
    <el-table-column
      v-if="selection"
      align="center"
      :fixed="selectionFixed"
      :reserve-selection="!!rowKey"
      :selectable="selectableFunc"
      type="selection"
      width="55"
    ></el-table-column>
    <el-table-column
      v-if="showIndex"
      align="center"
      type="index"
      width="50"
    ></el-table-column>
    <el-table-column
      v-for="(col, cindex) in cols"
      :key="col.prop+cindex"
      :resizable="col.attrs ? col.attrs.resizable : false"
      :prop="col.prop"
      v-bind="col.attrs"
    >
      <template slot="header">
        <template v-if="col.headerSlot">
          <slot :name="col.prop + 'HeaderSlot'"></slot>
        </template>
        <template v-else>
          {{ col.attrs.label }}
          <el-tooltip v-if="tabValue == 'fxg' && col.prop == 'outerId'" popper-width="200px" class="item" effect="dark" content="此处的款式编码预览为商品id或货号，准确的商品款式编码请以下载到系统的商品为准" placement="top-start">
            <i class="el-icon-Group-21"></i>
          </el-tooltip>
        </template>
      </template>
      <template slot-scope="scope">
        <slot v-if="col.slot" :name="col.prop + 'Slot'" v-bind="scope"></slot>
        <template v-else>{{ scope.row[col.prop] }}</template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    selection: {
      type: Boolean,
      default: false,
    },
    selectionFixed: {
      type: String,
      default: "",
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    cols: {
      type: Array,
      default() {
        return [];
      },
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    rowHeight: {
      type: Number,
      default: 0,
    },
    rowKey: {
      type: String,
      default: "",
    },
    
    attrs: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pagination: {
      type: Object,
      default: () => {
        return {
          pageNo: 1,
          pageSize: 1
        }
      }
    },
    tabValue:{
      type: String,
      default: ""
    },
    selectableFunc: {
      type: Function,
      default: () => {
        const func = () => {
          return true;
        }
        return func
      }
    },
    rowStyle: Object,
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit("selection-change", selection);
    },
    clearSelection() {
      this.$refs.table.clearSelection();
    },
    clearSort() {
      this.$refs.table.clearSort();
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-table ::v-deep .el-table__fixed-body-wrapper{
    overflow-y: hidden;
  }
</style>
